import React from 'react';
import cover from '../../../../Assets/Images/noskhe-cover.jpg'

function CardItem(props) {
    return (
        <>
            <div className='flex flex-col space-y-2'>
                <img src={cover} alt='cover' className='w-[100px] h-[100px] lg:w-[100px] lg:h-[100px] xl:w-[120px] xl:h-[120px] rounded'/>
                <div className="flex flex-row justify-center text-center items-center text-xs">
                    <div className='flex flex-col'>
                        <div className='font-medium'>{props.name}</div>
                        <div className='text-gray-800'>{props.artist}</div>
                    </div>
                    {/*<a href="#" className='bg-violet-200 hover:bg-violet-600 transition rounded-full p-2 text-purple-800 hover:text-purple-100'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="currentColor" className="w-4 h-4 ">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"/>
                        </svg>
                    </a>*/}
                </div>
            </div>
        </>
    );
}

export default CardItem;